<template>
  <div class="container-fluid h-100">
    <div class="row justify-content-center align-items-center h-100">
        <div class="col col-sm-6 col-md-6 col-lg-4 col-xl-3 pt-5">
          <card>
            <img class="img-fluid" src="img/breaze-black-logo.png" alt="">
            <h4 slot="header" class="card-title text-center">You've Logged Out Successfully</h4>
            <form>
              <div class="text-center">
                <a href="/#/login">Back To Login</a>
              </div>
              <div class="clearfix"></div>
            </form>
          </card>
        </div>
      </div>
  </div>
</template>
<script>
  import { getAuth, signOut } from "firebase/auth";
  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    data () {
      return {
        emailAddress: '',
        password: ''
      }
    },
    created () {
      this.attemptLogout()
    },
    methods: {
      async attemptLogout () {
        try {
          const auth = getAuth();
          await signOut(auth)
        } catch (error) {
          alert(error)
        }
      },
    }
  }

</script>
<style>

</style>
